import { ApiError, PaginatedResponse } from '@gorila-shared-ui/components';
import { InternalUser, User } from '../types/user';
import { deleteRequest, getRequest, postRequest } from './api';
import { userUrl, usersUrl } from './urls/userUrls';

export const getUsers = async (
  clientId: string,
  subClientId: string,
  page: number = 1,
  search: string = ''
): Promise<{ paginatedResponse?: PaginatedResponse<User>; error?: ApiError }> => {
  const response = await getRequest(usersUrl, { queryParams: { clientId, subClientId, page, search } });
  return {
    paginatedResponse: response?.data,
    error: response?.error,
  };
};

export const deleteUser = async (
  clientId: string,
  subClientId: string,
  userId: string
): Promise<{ error?: ApiError }> => {
  const response = await deleteRequest(userUrl(userId), { queryParams: { clientId, subClientId } });

  return {
    error: response?.error,
  };
};

export const updateUser = async (
  clientId: string,
  subClientId: string,
  user: InternalUser
): Promise<{ id?: string; error?: ApiError }> => {
  const { subAccount, _id, ...rest } = user;
  const response = await postRequest(userUrl(_id), {
    body: { ...rest, clientId, subClientId, subAccountId: subAccount?._id ?? undefined },
  });

  return {
    id: response?.data?.id,
    error: response?.error,
  };
};

export const postUser = async (
  clientId: string,
  subClientId: string,
  user: InternalUser
): Promise<{ id?: string; error?: ApiError }> => {
  const { _id, subAccount, ...rest } = user;
  const response = await postRequest(usersUrl, {
    body: { ...rest, clientId, subClientId, subAccountId: subAccount?._id || undefined },
  });
  return {
    id: response?.data?._id,
    error: response?.error,
  };
};
